import React from 'react';
import { isCapacitorAvailable } from '../../capacitor-utils';

interface CapacitorContainerProps {
  children: React.ReactNode;
}

// Check Capacitor environment once at module load time, not on every render
const IS_NATIVE_APP = isCapacitorAvailable();

/**
 * This component provides a simple container that marks content as being inside Capacitor
 * We've moved away from a global solution for safe areas and status bars
 * Instead, we'll handle those on a per-screen basis
 */
export function CapacitorContainer({ children }: CapacitorContainerProps) {
  if (!IS_NATIVE_APP) {
    // In web browser, just render children normally in a full-height container
    return <div className="mobile-app-container">{children}</div>;
  }

  // In Capacitor native app, use our container class
  return (
    <div id="capacitor-root-container" className="capacitor-app-container">
      {children}
    </div>
  );
}
